import { render, staticRenderFns } from "./DocumentPortalSetupPreviewView.vue?vue&type=template&id=689f37bd&scoped=true&"
import script from "./DocumentPortalSetupPreviewView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupPreviewView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f37bd",
  null
  
)

export default component.exports